export enum EnumStatusPedido {
   AguardandoInicio = 1,
   EmProducao = 2,
   Finalizado = 3,
   SolicitacaoCancelamentoAtendimento = 4,
   SolicitacaoCancelamentoProducao = 5,
   Cancelado = 6,
   AguardandoRetirada = 9,
   EmEntrega = 10,
}